export const hotel = {
  evaluation: "Evaluation：{{num}}",
  perNightPerRoom: "{{price}} / Per night per room",
  perNightPerPerson: "{{price}} / Per night per toom",
  room: "Room：{{name}}",
};
